module.exports = __webpack_public_path__ + "img/selected2-min.19ee1c03.png";